module.exports = __webpack_public_path__ + "img/home-btn-addfund.aafc6e96.svg";